import ClearittyLogoAndText from "@/assets/icons/clearitty-logo-and-text.svg";
import QuotaLogo from "@/assets/icons/quotaLogo.svg";

interface LoginHeaderProps {
    showQuotaPartnership?: boolean;
}

export function LoginHeader({ showQuotaPartnership }: LoginHeaderProps) {
    return (
        <div className='flex flex-col items-start pl-[8px] pt-[8px]'>
            <div className='flex flex-col items-center mb-8 lg:mb-0'>
                <div className="flex items-center justify-center lg:justify-start gap-2">
                    <ClearittyLogoAndText />
                </div>
                {showQuotaPartnership && (
                    <div className='flex flex-col items-center justify-start'>
                        In partnership with
                        <QuotaLogo className='w-[120px] h-[60px]' />
                    </div>
                )}
            </div>
        </div>
    );
}
